import * as Sentry from '@sentry/react';
import { CloudStorageTelegram } from './cloud-storage.telegram';


export const cloudStorage = new CloudStorageTelegram(Sentry);
